module.exports = __webpack_public_path__ + "static/media/empty-cart.2f902552.svg";